import { useState, useEffect } from "react";

export const useVisibilityElement = ({
  targetId,
  initialVisible = false,
  margin = 0,
  triggerOnce = false,
  threshold = 0,
}) => {
  const [isVisible, setIsVisible] = useState(initialVisible);

  useEffect(() => {
    let observer = null;
    let retries = 0;
    const maxRetries = 10;
    const interval = 100;

    const tryObserve = () => {
      const targetElement = document.getElementById(targetId);
      if (!targetElement) {
        if (retries < maxRetries) {
          retries++;
          setTimeout(tryObserve, interval);
        }
        return;
      }

      observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            if (triggerOnce) observer?.unobserve(entry.target);
          } else if (!triggerOnce) {
            setIsVisible(false);
          }
        },
        {
          rootMargin: `-${margin}px 0px -${margin}px 0px`,
          threshold,
        }
      );

      observer.observe(targetElement);
    };

    tryObserve();

    return () => {
      observer?.disconnect();
    };
  }, [targetId, margin, triggerOnce, threshold]);

  return { isVisible };
};
